
import { getLang } from "@/plugins/env"
import { trackFooterClick } from "@/utils/track"
export default {
  name: "Bottom",
  // serverCacheKey: _ => {
  //   return `${getLang()}_PageFooter`
  // },
  data() {
    return {
      lang: this.$i18n.locale,
      wellcomeList: [
        {
          name: "ourStory",
          url_zh_HK: this.$t("footer.ourStoryLink"),
          url_en_US: this.$t("footer.ourStoryLink")
        },
        {
          name: "ourBrands",
          url_zh_HK: this.$t("footer.ourBrandsLink"),
          url_en_US: this.$t("footer.ourBrandsLink")
        },
        {
          name: "ourCommitment",
          url_zh_HK: this.$t("footer.ourCommitmentLink"),
          url_en_US: this.$t("footer.ourCommitmentLink")
        },
        {
          name: "storeLocator",
          url_zh_HK: this.$t("footer.storeLocatorLink"),
          url_en_US: this.$t("footer.storeLocatorLink")
        },
        {
          name: "careers",
          url_zh_HK: this.$t("footer.careersLink"),
          url_en_US: this.$t("footer.careersLink")
        }
      ]
      // wellcomeListOther: [
      //   {
      //     name: "storeLocator",
      //     url_zh_HK: this.$t("footer.storeLocatorLink"),
      //     url_en_US: this.$t("footer.storeLocatorLink")
      //   },
      //   {
      //     name: "careers",
      //     url_zh_HK: this.$t("footer.careersLink"),
      //     url_en_US: this.$t("footer.careersLink")
      //   }
      // ]
    }
  },
  computed: {},
  methods: {
    goDfiPage() {
      if (this.lang === "zh_HK") {
        window.open("https://www.dfiretailgroup.com/zh-HK")
      } else {
        window.open("https://www.dfiretailgroup.com/en")
      }
    },
    goAbout() {
      if (this.lang === "zh_HK") {
        window.open("https://www.yuurewards.com/zh-hant/faq?categoryKey=Wellcome.com.hk")
      } else {
        window.open("https://www.yuurewards.com/en/faq?categoryKey=Wellcome.com.hk")
      }
    },
    goTerms() {
      const termsAndConditionsLink = this.$t("footer.termsAndConditionsLink")
      window.open(termsAndConditionsLink)
    },
    goPolicy() {
      const privacyPolicyLink = this.$t("footer.privacyPolicyLink")
      window.open(privacyPolicyLink)
    },
    handleJump(type) {
      let name = ""
      switch (type) {
        case "email":
          name = "Contact us email"
          location.href = "mailto:" + this.$t("footer.email")
          break
        case "faq":
          name = "FAQs"
          this.goAbout()
          break
        case "terms":
          name = "Terms & Conditions"
          this.goTerms()
          break
        case "policy":
          name = "Privacy Policy"
          this.goPolicy()
          break
        case "dfi":
          name = "DFI Retail Group"
          this.goDfiPage()
          break
        case "productRecall":
          this.goProductRecall()
          break
        case "emailBulkorder":
          location.href = "mailto:" + this.$t("footer.emailBulkorderLink")
          break
        default:
          break
      }
      this.trackFooterClick(name)
    },
    trackFooterClick,
    goItemLink(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      return url
    },
    openDownladStore(url) {
      window.open(url)
    },
    goProductRecall() {
      const productRecallLink = this.$t("footer.productRecallLink")
      window.open(productRecallLink)
    }
  }
}
